<div
  class="resume modern"
  [style.--themeColor]="color"
  [style.font-family]="font"
>
  <div class="header" [ngClass]="{ 'no-image-header': !data.config.photoUrl }">
    <div class="left">
      <ng-container *ngIf="data?.config?.photoUrl; else noImage">
        <div class="profile-row">
          <img [src]="data.config.photoUrl" crossorigin="anonymous" />

          <div class="name-box">
            <h1 *ngIf="data?.personal_info?.fullName">
              {{ data.personal_info.fullName }}
            </h1>

            <p class="role" *ngIf="data?.targetRole">
              {{ data.targetRole }}
            </p>
          </div>
        </div>
      </ng-container>

      <ng-template #noImage>
        <div class="name-box">
          <h1 *ngIf="data?.personal_info?.fullName">
            {{ data.personal_info.fullName }}
          </h1>

          <p class="role" *ngIf="data?.targetRole">
            {{ data.targetRole }}
          </p>
        </div>
      </ng-template>
    </div>
  </div>

  <div
    class="contact-bar"
    *ngIf="
      data?.personal_info?.email ||
      data?.personal_info?.phone ||
      data?.personal_info?.location ||
      data?.personal_info?.linkedinUrl ||
      data?.personal_info?.githubUrl
    "
  >
    <span *ngIf="data?.personal_info?.email">
      <i class="bi bi-envelope me-1"></i>
      {{ data.personal_info.email }}
    </span>

    <span *ngIf="data?.personal_info?.phone">
      <i class="bi bi-telephone me-1"></i>
      {{ data.personal_info.phone }}
    </span>

    <span *ngIf="data?.personal_info?.location">
      <i class="bi bi-geo-alt me-1"></i>
      {{ data.personal_info.location }}
    </span>

    <span *ngIf="data?.personal_info?.linkedinUrl">
      <i class="bi bi-linkedin me-1"></i>
      {{ data.personal_info.linkedinUrl }}
    </span>

    <span *ngIf="data?.personal_info?.githubUrl">
      <i class="bi bi-github me-1"></i>
      {{ data.personal_info.githubUrl }}
    </span>
  </div>

  <div class="divider"></div>

  <div class="body">
    <div class="left">
      <div class="section" *ngIf="data?.summary">
        <h3>Profile</h3>
        <p>{{ data.summary }}</p>
      </div>

      <div class="section" *ngIf="data?.experience?.length">
        <h3>Experience</h3>

        <ng-container *ngFor="let e of data.experience">
          <div class="item" *ngIf="e?.role || e?.company">
            <div class="exp-row">
              <b *ngIf="e?.role">{{ e.role }}</b>

              <span *ngIf="e?.startYear || e?.endYear || e?.currently_working">
                <ng-container *ngIf="e?.startMonth || e?.startYear">
                  {{ e.startMonth }} {{ e.startYear }}
                </ng-container>

                <span
                  *ngIf="e?.startYear && (e?.endYear || e?.currently_working)"
                >
                  -
                </span>

                <ng-container *ngIf="e?.currently_working">
                  Present
                </ng-container>

                <ng-container *ngIf="!e?.currently_working">
                  {{ e.endMonth }} {{ e.endYear }}
                </ng-container>
              </span>
            </div>

            <p class="muted" *ngIf="e?.company || e?.location">
              {{ e.company }}
              <span *ngIf="e?.company && e?.location">, </span>
              {{ e.location }}
            </p>

            <p *ngIf="e?.description">
              {{ e.description }}
            </p>
          </div>
        </ng-container>
      </div>

      <div class="section" *ngIf="data?.projects?.length">
        <h3>Projects</h3>

        <ng-container *ngFor="let p of data.projects">
          <div class="item" *ngIf="p?.title || p?.description">
            <b *ngIf="p?.title">{{ p.title }}</b>

            <p class="muted" *ngIf="p?.technologies?.length">
              {{ p.technologies.join(" • ") }}
            </p>

            <p *ngIf="p?.description">
              {{ p.description }}
            </p>

            <p *ngIf="p?.outcome">↗ {{ p.outcome }}</p>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="right">
      <div
        class="card"
        *ngIf="
          data?.skills?.technicalSkills?.length ||
          data?.skills?.tools?.length ||
          data?.skills?.softSkills?.length
        "
      >
        <h3>Skills</h3>

        <p *ngIf="data?.skills?.technicalSkills?.length">
          <b>Tech:</b>
          {{ data.skills.technicalSkills.join(", ") }}
        </p>

        <p *ngIf="data?.skills?.tools?.length">
          <b>Tools:</b>
          {{ data.skills.tools.join(", ") }}
        </p>

        <p *ngIf="data?.skills?.softSkills?.length">
          <b>Soft:</b>
          {{ data.skills.softSkills.join(", ") }}
        </p>
      </div>

      <div class="divider" *ngIf="data?.extras?.certifications?.length"></div>

      <div class="card" *ngIf="data?.extras?.certifications?.length">
        <h3>Certifications</h3>

        <ng-container *ngFor="let c of data.extras.certifications">
          <p *ngIf="c?.name || c?.platform || c?.year">
            <span *ngIf="c?.name">• {{ c.name }}</span>

            <span *ngIf="c?.platform || c?.year">
              <span *ngIf="c?.name"> (</span>
              {{ c.platform }}
              <span *ngIf="c?.platform && c?.year"> - </span>
              {{ c.year }}
              <span *ngIf="c?.name">)</span>
            </span>
          </p>
        </ng-container>
      </div>

      <div class="divider" *ngIf="data?.extras?.awards?.length"></div>

      <div class="card" *ngIf="data?.extras?.awards?.length">
        <h3>Awards</h3>

        <ng-container *ngFor="let a of data.extras.awards">
          <p *ngIf="a?.name || a?.organization">
            <span *ngIf="a?.name">• {{ a.name }}</span>

            <span *ngIf="a?.organization"> ({{ a.organization }}) </span>
          </p>
        </ng-container>
      </div>

      <div class="divider" *ngIf="data?.extras?.languages?.length"></div>

      <div class="card" *ngIf="data?.extras?.languages?.length">
        <h3>Languages</h3>

        <ng-container *ngFor="let l of data.extras.languages">
          <p *ngIf="l?.name">
            <span *ngIf="l?.name">• {{ l.name }}</span>

            <span *ngIf="l?.proficiency"> ({{ l.proficiency }}) </span>
          </p>
        </ng-container>
      </div>

      <div class="divider" *ngIf="data?.extras?.hackathons?.length"></div>

      <div class="card" *ngIf="data?.extras?.hackathons?.length">
        <h3>Hackathons</h3>

        <ng-container *ngFor="let h of data.extras.hackathons">
          <p *ngIf="h?.name || h?.rank">
            <span *ngIf="h?.name">• {{ h.name }}</span>

            <span *ngIf="h?.rank"> ({{ h.rank }}) </span>
          </p>
        </ng-container>
      </div>
    </div>
  </div>
</div>
